import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enStrings from './en.json';
import frStrings from './fr.json';

export const defaultNamespace = 'default';

export const resources = {
  en: {
    [defaultNamespace]: enStrings,
  },
  fr: {
    [defaultNamespace]: frStrings,
  },
};

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'fr'],
    fallbackLng: 'en',
    defaultNS: defaultNamespace,
    ns: [defaultNamespace],
    resources,
    interpolation: {
      escapeValue: false,
    },
  });
